import { TextInput } from '@src/common/components/TextInput';
import type { SearchPermitFilters } from '@src/permits/services/PermitApplicationClient';
import { useTranslation } from 'react-i18next';

export interface Props {
  onFilterChange: (filters: SearchPermitFilters) => void;
  value?: string;
}

export const TractorVINFilter = ({ onFilterChange, value }: Props) => {
  const { t } = useTranslation();

  return (
    <TextInput
      label={t('permitSearch.vin')}
      value={value}
      onChange={(e) => {
        onFilterChange({ tractorVIN: e.target.value as string });
      }}
    />
  );
};
